import React from 'react';
import { Person, Scorecard } from 'talent_matching/types';
import Container from '@grnhse/seedling/lib/birch/components/container';
import { Stack } from '@grnhse/seedling/lib/birch/layouts/stack_v2';
import { Grid } from '@grnhse/seedling/lib/birch/layouts/grid_v2';
import { SecondaryButton } from '@grnhse/seedling/lib/birch/components/buttons';
import {
  SecondaryBody,
  TertiaryBody,
} from '@grnhse/seedling/lib/birch/typography';
import { FeedbackItem } from 'talent_matching/components/table/feedback_cell';
import { withLocalePrefix } from 'shared/utils/translation';

const t = withLocalePrefix('talent_matching.panel.feedback');

type Props = {
  candidate: Person | null;
  openFeedbackModal: () => void;
};

const FeedbackCard = ({
  scorecard,
  openFeedbackModal,
}: {
  scorecard: Scorecard;
  openFeedbackModal: () => void;
}) => {
  const date = new Date(scorecard.submitted_at).toLocaleDateString(undefined, {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });

  return (
    <Container>
      <Stack direction="column" spacing={1}>
        <Stack direction="row" justifyContent="space-between">
          <Stack direction="row" spacing={0.5}>
            <SecondaryBody medium className="pii-blur">
              {scorecard.author}
            </SecondaryBody>
            {scorecard.is_current_user && (
              <SecondaryBody>{t('you')}</SecondaryBody>
            )}
          </Stack>
          <SecondaryBody metadata>{date}</SecondaryBody>
        </Stack>
        <FeedbackItem scorecard={scorecard} showYou={false} />
        {scorecard.body && (
          <div className="pii-blur">
            <TertiaryBody
              dangerouslySetInnerHTML={{ __html: scorecard.body }}
            />
          </div>
        )}
        {scorecard.is_current_user && (
          <Grid>
            <SecondaryButton onClick={openFeedbackModal} size="sm">
              {t('edit')}
            </SecondaryButton>
          </Grid>
        )}
      </Stack>
    </Container>
  );
};

const FeedbackTabPanel = ({ candidate, openFeedbackModal }: Props) => {
  if (!candidate?.scorecards || candidate.scorecards.length === 0) {
    return null;
  }

  return (
    <Stack direction="column" spacing={2}>
      {candidate.scorecards.map((scorecard) => (
        <FeedbackCard
          key={scorecard.id}
          scorecard={scorecard}
          openFeedbackModal={openFeedbackModal}
        />
      ))}
    </Stack>
  );
};

export default FeedbackTabPanel;
